import { render } from "./PuzzleCollectionView.vue?vue&type=template&id=f9126e30&scoped=true"
import script from "./PuzzleCollectionView.vue?vue&type=script&lang=js"
export * from "./PuzzleCollectionView.vue?vue&type=script&lang=js"

import "./PuzzleCollectionView.vue?vue&type=style&index=0&id=f9126e30&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9126e30"]])

export default __exports__